import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { Tooltip, Typography } from '@nextiva/next-ui-components';
import { ReactComponent as Download } from './assets/download.svg';

import { INVOICE_FILE_NOT_AVAILABLE } from 'constant';
import { formatter } from 'utils';

import './Invoice.scss';

export const blockName = 'invoice';

const Invoice = ({
  amount,
  eventId,
  formattedDate,
  invoiceFileAvailable,
  invoiceStatus,
  invoiceType,
  startGetInvoicePDF,
}) => {
  const CUSTOMER_TRX_SIZE = 14;

  const handleDownloadInvoicePDF = useCallback(() => {
    startGetInvoicePDF(eventId);
  }, [eventId, startGetInvoicePDF]);

  return (
    <article className={blockName} data-testid={blockName}>
      <Typography className={`${blockName}__large-column`}>
        <Tooltip title={invoiceFileAvailable ? '' : INVOICE_FILE_NOT_AVAILABLE}>
          <Typography
            className={`${blockName}--blue-text`}
            component="span"
            sx={{ fontSize: CUSTOMER_TRX_SIZE }}
          >
            {eventId}
          </Typography>
        </Tooltip>
        {invoiceFileAvailable && (
          <IconButton
            className={`${blockName}__pdf`}
            onClick={handleDownloadInvoicePDF}
          >
            <Download id={eventId} />
          </IconButton>
        )}
      </Typography>
      <Typography>{formattedDate}</Typography>
      <Typography>{invoiceType}</Typography>
      <Typography className={`${blockName}__short-column`}>
        {invoiceStatus}
      </Typography>
      <Typography className={`${blockName}__short-column`}>
        {formatter.format(amount)}
      </Typography>
    </article>
  );
};

Invoice.propTypes = {
  eventId: PropTypes.string.isRequired,
  formattedDate: PropTypes.string.isRequired,
  invoiceType: PropTypes.string.isRequired,
  invoiceStatus: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  startGetInvoicePDF: PropTypes.func.isRequired,
  invoiceFileAvailable: PropTypes.bool.isRequired,
};

export default Invoice;
